import UserCookie from 'vue-cookies'

export default function admin ( { next } ) {
    const isLoggedIn = UserCookie.get('loggedin')
    const isAdmin = UserCookie.get('admin_id')
    const isAdminRole = UserCookie.get('user_type') && UserCookie.get('user_type') === 'admin'
    const isAcuRole = UserCookie.get('user_type') && UserCookie.get('user_type') === 'acu'
    // console.log()
    if (isLoggedIn && isAdmin && (isAdminRole || isAcuRole))
        return next()
    else {
        return next('/admin/login')
    }
}
